/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Col, Row, Typography } from 'antd';
import NutritionCalculationTable from '@/components/tables/nutritional-menu-calculator-management/nutrition-calculation.table';
import CalculationConditionsTable from '@/components/tables/nutritional-menu-calculator-management/calculation-conditions.table';

import {
  watchListResult
} from '@/redux/slices/nutritional-menu-calculator.slice';
import { useAppSelector } from '@/redux/hooks';
import { useState } from 'react';

export default function NutritionalMenuCalculatorManagement() {
  const listResult = useAppSelector(watchListResult);
  const [selectedRowTargetProfile, setSelectedRowTargetProfile] = useState<TargetProfileListNutritionalMenuCalculator | null>(null);
  const [valueForm, setValueForm] = useState<any | null>(null);

  return (
    <div css={rootStyles}>
      <>
        <Row css={boxStyles} justify="space-between" align="middle">
          <Col>
            <Typography.Title css={titleStyles} level={5}>
              Tính toán dinh dưỡng
            </Typography.Title>
          </Col>
        </Row>
      </>
      <div css={contentRowStyles}>
        <Row gutter={16}>
          <Col span={12} css={contentStyles}>
            <NutritionCalculationTable setRowTargetProfile={setSelectedRowTargetProfile} setValueForm={setValueForm} />
          </Col>

          <Col span={12} css={contentStyles} style={{ marginLeft: '0.5rem' }}>
            <CalculationConditionsTable listResult={listResult || undefined} selectedRowTargetProfile={selectedRowTargetProfile} valueForm={valueForm} />
          </Col>
        </Row>
      </div>
    </div>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const contentStyles = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const contentRowStyles = css`
    .ant-row {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
`

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;
